// extracted by mini-css-extract-plugin
export default {"page":"style_page__2QEr0","emoji":"style_emoji__cNwC6","title":"style_title__f2T97","subtitle":"style_subtitle__TnAHV","spacer":"style_spacer__9TRvQ"};